import { FormGroup } from '@angular/forms';

import { InvalidFormParam } from './api.interface';

export class FormattedError {
  constructor(
    private readonly html: string,
    private readonly invalidFormParams: InvalidFormParam[],
    private readonly formParamsFormatter: (invalidParams: InvalidFormParam[], formGroups: FormGroup[]) => string
  ) { }

  format(formGroups: FormGroup[] = []): string {    
    if(this.invalidFormParams.length > 0) {
      return this.formParamsFormatter(this.invalidFormParams, formGroups);
    }

    return this.html;
  }
}